import { ChangeEvent, FC } from 'react';
// Components
import Sidebar from 'components/Sidebar';
import { Select } from 'components/Controls';
// Hooks
import { IConfig, Direction } from 'hooks/useSortableItems';
// i18next
import { useTranslation } from 'react-i18next';

type Props = {
  sortConfig: IConfig;
  onRequestSort: (key:string, direction:Direction) => void;
}

const NamespacesSort:FC<Props> = ({
  // Props
  sortConfig, onRequestSort
}) => {
  const { t } = useTranslation();

  const handleChange = (event:ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = event.target;
    const key = name === 'key' ? value : sortConfig.key;
    const direction = name === 'key' ? sortConfig.key : value;
    onRequestSort(key, direction as Direction);
  }

  const directionOptions = (Object.keys(Direction) as Array<keyof typeof Direction>).map((direction) => ({
    value: Direction[direction], label: direction
  }));

  return (
    <Sidebar>
      <Select
        label={t('labels.sortBy')} id="sortBy" name="key" value={sortConfig.key}
        onChange={handleChange}
        options={[
          { value: 'name', label: t('labels.name') },
          { value: 'createdByName', label: t('labels.createdBy') },
          { value: 'createdAt', label: t('labels.dateCreated') }
        ]}
      />
      <Select
        label={t('labels.direction')} id="direction" name="direction" value={sortConfig.direction}
        onChange={handleChange}
        options={directionOptions}
      />
    </Sidebar>
  )
}

export default NamespacesSort;
